import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalConfig} from '../../models/modal-config.model';

@Component({
  selector: 'app-modal-popup-component',
  templateUrl: './modal-popup-component.html',
  styleUrl: './modal-popup-component.scss',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements OnDestroy {
  /** Full configuration object — every property maps 1-to-1 with ModalConfig */
  @Input() config: ModalConfig | null = null;

  /** Emitted when the user clicks the confirm (primary) button */
  @Output() confirm = new EventEmitter<void>();

  /** Emitted when the user clicks the reject (secondary) button */
  @Output() reject = new EventEmitter<void>();

  /** Emitted when the modal is closed via the × button or backdrop */
  @Output() closeModal = new EventEmitter<void>();

  /** Controls visibility — kept alive in DOM when keepModalAlive is true */
  @Input() isVisible: boolean = false;

  get configSafe(): ModalConfig {
    return this.config ?? {};
  }

  get isStacked(): boolean {
    return this.configSafe.type === 'StackedButtons';
  }

  onConfirm(): void {
    this.confirm.emit();
    this.close();
  }

  onReject(): void {
    this.reject.emit();
    this.close();
  }

  onClose(): void {
    this.close();
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.close();
    }
  }

  private close(): void {
    if (!this.configSafe.keepModalAlive) {
      this.isVisible = false;
    }
    this.closeModal.emit();
  }

  ngOnDestroy(): void {}
}
